var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['grid', 'grid-cols-1', 'mx-0', '-mt-1', 'md:mt-0', 'md:pt-2']},_vm._l((_vm.results),function(result,index){return _c('li',{key:'web-result-' + index,class:['flex', 'flex-col', 'pt-0', 'pb-0', 'last:mb-2', 'px-0', 'relative'],attrs:{"tabindex":"0"},on:{"mouseenter":function($event){$event.stopPropagation();return _vm.hover(index)},"mouseleave":function($event){$event.stopPropagation();return _vm.stopHover(index)},"click":function($event){return _vm.select(result.url)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.select(result.url)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.select(result.url)}]}},[_c('div',{class:[
        'rounded-xl',
        'focus:ring-2',
        'focus:ring-grape-500',
        'dark:focus:ring-canary-500',
        'focus:ring-opacity-100',
        'hover-hover:hover:ring-2',
        'hover-hover:hover:ring-grape-500',
        'hover-hover:dark:hover:ring-canary-500',
        'hover-hover:hover:ring-opacity-100',
        'only:hide-separator',
        'last:hide-separator',
        'cursor-pointer',
        'px-2',
        'py-3' ]},[_c('div',{staticClass:"font-semibold text-17-22 text-highway-100 dark:text-white-100 mb-1"},[_vm._v(_vm._s(result.title))]),_vm._v(" "),_c('div',{staticClass:"font-normal text-body-extra-small leading-4 text-highway-100 dark:text-white-100 mb-1"},[_vm._v("\n        "+_vm._s(result.description)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"truncate font-normal text-12-15 mt-1 text-highway-300 dark:text-white-200"},[_vm._v(_vm._s(result.url))])]),_vm._v(" "),_c('div',{class:[
        'separator',
        'border-solid',
        'border-highway-disabled',
        'dark:border-white-disabled',
        'border-t',
        'absolute',
        'bottom-0',
        'left-0',
        'right-0',
        _vm.hoveringOn === index || _vm.hoveringOn - 1 === index ? 'hidden' : '' ],attrs:{"role":"separator"}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }